import { useMediaQuery, useTheme } from "@mui/material";
import TargetDesktop from "../components/desktop/target/TargetDesktop";

const Target = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <TargetDesktop />
    </>
  );
};

export default Target;
